import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Sidebar from '../../../../../components/Sidebar';
import styles from './sidebarAddEligiblePlayers.scss';
import { addEligiblePlayerIDsByOrganizer } from '../../../../../actions/event-profile-actions';

const SidebarAddEligiblePlayers = (props) => {
  const {
    eventId,
    onClose,
    onSubmitSuccess,
  } = props;
  const [value, setValue] = useState('');
  const [validationError, setValidationError] = useState(undefined);
  const dispatch = useDispatch();

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData('text');
    const numbers = paste
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(line => /^[0-9]+$/.test(line))
      .join('\n');

    setValue(prevValue => {
      return prevValue ? `${prevValue}\n${numbers}` : numbers;
    });
  };

  const handleChange = (event) => {
    setValidationError(false);
    const input = event.target.value;
    const filteredLines = input
      .split(/\r?\n/)
      .map(line => line.replace(/[^0-9]/g, ''));
    const filteredInput = filteredLines.join('\n');
    setValue(filteredInput);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const playerIDs = value.split('\n').filter(line => line.trim() !== '');
    const parsedPlayerIDs = playerIDs.map((playerId) => parseInt(playerId));
    if (!playerIDs.length) {
      setValidationError('No player IDs were provided. Please submit at least 1 player ID');
      return;
    }
    if (playerIDs.length > 1000) {
      setValidationError('No more than 1000 players can be submitted at once. Please enter 1000 IDs or less');
      return;
    }
    const payload = {
      playerIds: parsedPlayerIDs,
    };
    const res = await dispatch(addEligiblePlayerIDsByOrganizer(eventId, payload));
    if (res.success) {
      onClose();
      onSubmitSuccess(res.data);
    }
  };

  return (
      <Sidebar onClose={onClose}>
          <div className={styles.sidebarContent}>
              <div>
                  <div className="text-highlight2 text-dark text-center mt32" data-testid="event-profile.add-eligible-players.title">
                    Add eligible player IDs
                  </div>
                  <div className="utr-text text-dark text-left mt24 mb8" data-testid="event-profile.add-eligible-players.subtitle">ADD PLAYER IDS</div>
              </div>
              <form onSubmit={handleSubmit} className={styles.sidebarForm} data-testid="event-profile.add-eligible-players.form">
                  {validationError && <p className={styles.validationError} data-testid="event-profile.add-eligible-players.validation-error">{validationError}</p>}
                  <textarea
                      value={value}
                      onChange={handleChange}
                      onPaste={handlePaste}
                      placeholder="Enter or paste player IDs here, one ID per line. Only 1000 allowed per submission."
                      className={`${styles.playersInput} ${validationError ? styles.playersInputWithError : ''}`}
                      data-testid="event-profile.add-eligible-players.player-ids-input"
                  />
                  <button
                      type="submit"
                      className="btn btn-primary btn-xl btn-block text-uppercase mt24"
                      data-testid="event-profile.add-eligible-players.submit-btn"
                  >
                    ADD PLAYERS
                  </button>
              </form>
          </div>
      </Sidebar>
  );
};

SidebarAddEligiblePlayers.propTypes = {
  eventId: PropTypes.number,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
};

SidebarAddEligiblePlayers.defaultProps = {
  eventId: '',
  onClose: () => { },
  onSubmitSuccess: () => { },
};

export default withRouter(SidebarAddEligiblePlayers);
